module.exports = __webpack_public_path__ + "static/media/photo-10.481c088f.avif";